import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="draft-detector"
// 下書きがlocalStorageに存在する場合、自動的に編集モードを開く
export default class extends Controller {
  static values = { key: String, editLink: String }

  connect() {
    if (!this.keyValue) return

    const draft = localStorage.getItem(this.keyValue)
    if (draft !== null && draft.trim() !== '') {
      // editLinkValueのhrefを持つリンクを探す（要素内 → ドキュメント全体）
      const link = this.element.querySelector(`a[href="${this.editLinkValue}"]`) ||
                   document.querySelector(`a[href="${this.editLinkValue}"]`)
      if (link) {
        link.click()
      }
    }
  }
}
